import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { BillingManagementService } from 'src/service/billing-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { KeyValueIdForPaymentMode, KeyValueIdForPaymentModeWrapper, KeyValueSet, LastUsedKey, LastUsedSettingsType, LocalService, NumericConfig, PaymentType, Status } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';

@Component({
  selector: 'app-bill-payment-types',
  templateUrl: './bill-payment-types.component.html',
  styleUrl: './bill-payment-types.component.scss'
})
export class BillPaymentTypesComponent {
  PaymentType = PaymentType;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onSelected = new EventEmitter();
  @Output() onPaid = new EventEmitter();

  @Input() paymentMethods: KeyValueSet[] = []; @Input() billAmount: number | null = null;
  @Input() businessId: string = ''; @Input() selectedPaymentMode: string = '';
  @Input() receiptId: string = ''; @Input() isPaid: boolean = false; @Input() isRemainingPayment: boolean = false;
  @Input() isShowPayAndPrint: boolean = false; @Input() isShowPayAndSendToPhone: boolean = false;

  lstSectionConfigKeys: string[] = ["billing"]; currencyIcon = ''; toBePaid: number | null = null;
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig; isPaidAmountEditable = false;
  totalPaidAmount = 0; totalLatePaidAmount = 0;

  paymentDetails: KeyValueIdForPaymentModeWrapper = {
    items: [], latePayments: []
  } as KeyValueIdForPaymentModeWrapper;

  htmlId: string = ''; elementIds: any;
  constructor(public localService: LocalService, private billingManagementService: BillingManagementService, private languageManagementService: LanguageManagementService, private profileManagementService: ProfileManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      txt_to_be_paid: 'txt_to_be_paid_' + this.htmlId,
      btn_save: 'btn_save_' + this.htmlId,
      btn_pay: 'btn_pay_' + this.htmlId,
      btn_paymeny_mode: 'btn_paymeny_mode_' + this.htmlId,
      btn_pay_print: 'btn_pay_print_' + this.htmlId,
      btn_pay_send_phone: 'btn_pay_send_phone_' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpenPopup'] || changes['isPaid'] || changes['billAmount'] || changes['isRemainingPayment']) {
      if (this.isOpenPopup) {
        if (this.selectedPaymentMode == '0') {
          this.selectedPaymentMode = '';
        }
        this.onLoad();
      }
    }
  }

  onInitiate() {
    this.currencyIcon = this.localService.onGetCurrencyIcon(this.businessId);
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  onLoad() {
    if (!this.selectedPaymentMode) {
      this.localService.lastBillPaymentMethod = parseInt((this.localService.getLastUsedSetting(LastUsedSettingsType.PaymentType) ?? PaymentType.Others.toString()));

      this.selectedPaymentMode = this.localService.lastBillPaymentMethod.toString();
    }

    this.paymentMethods.forEach(paymentMethod => {
      if ([PaymentType.BulkUpdate].includes(parseInt(paymentMethod.key))) {
        paymentMethod.isInActive = true;
      }
      paymentMethod.s_value = '';
    });

    if (!this.selectedPaymentMode) {
      this.selectedPaymentMode = PaymentType.Upi.toString();
    }

    this.billingManagementService.getPaymentModeAmount(this.receiptId).subscribe(result => {
      this.paymentDetails = this.isRemainingPayment && !this.isPaid ? {
        items: [], latePayments: []
      } as KeyValueIdForPaymentModeWrapper : result;
      this.onSelectItem(this.selectedPaymentMode);
    });
  }

  onSetLastUsedSettings(key: string) {
    this.localService.lastBillPaymentMethod = parseInt(key);
    this.profileManagementService.saveLastUsedSetting({ keyType: LastUsedSettingsType.PaymentType, value: this.localService.lastBillPaymentMethod.toString() } as LastUsedKey).subscribe(result => {

    });
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.onClosePopup();
      } break;
      case 2: {
        this.onSelectItem(key);
        this.onSetLastUsedSettings(key);
      } break;
      case 3: {
        this.onSavePaymentDetails(false);
      } break;
      case 4: {
        this.onSavePaymentDetails(true);
      } break;
      case 5: {
        this.onSavePaymentDetails(true, true);
      } break;
      case 6: {
        this.onSavePaymentDetails(true, false, true);
      } break;
    }
  }

  onSavePaymentDetails(isPay: boolean, isPrint: boolean = false, isSendToPhone: boolean = false) {
    this.paymentDetails.items = [];
    if ([PaymentType.MultiPayment].includes(parseInt(this.selectedPaymentMode))) {
      this.paymentMethods.forEach(paymentMethod => {
        if (paymentMethod.s_value) {
          this.paymentDetails.items.push({
            k: parseInt(paymentMethod.key),
            v: parseInt(paymentMethod.s_value)
          } as KeyValueIdForPaymentMode);
        }
      });
    } else {
      this.paymentDetails.items.push({
        k: parseInt(this.selectedPaymentMode),
        v: this.toBePaid ?? this.billAmount
      } as KeyValueIdForPaymentMode);
    }
    this.billingManagementService.savePaymentModeAmount(this.businessId, this.receiptId, this.paymentDetails.items, isPay, this.isRemainingPayment).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (isPay
        && [Status.Success,
        Status.QrPaymentGenerated,
        Status.NeedBRN,
        Status.MinimumRequired,
        Status.SerialNumberRequired,
        Status.InventoryRequired].includes(result.status)) {
        this.onPaid.emit({
          isPrint: isPrint,
          status: result.status,
          isSendToPhone: isSendToPhone
        });
        this.onClosePopup();
      }
    });
  }

  onClosePopup() {
    this.isOpenPopup = false;
    this.isOpenPopupChange.emit(this.isOpenPopup);
  }

  onSelectItem(key: string) {
    this.paymentMethods.forEach(item => {
      item.isSelected = item.key == key;
    });
    this.selectedPaymentMode = key;
    this.isPaidAmountEditable = this.isPaid ? false : ![PaymentType.MultiPayment, PaymentType.ShowQrCode].includes(parseInt(key));
    this.onCalculateNonEditAmount();
    if (this.isPaid) {
      this.totalPaidAmount = this.paymentDetails.items.reduce((sum, current) => sum + current.v, 0);
      this.totalLatePaidAmount = this.paymentDetails.latePayments.reduce((sum, current) => sum + current.paidAmount, 0);

      this.toBePaid += this.totalLatePaidAmount;
    }
    this.onSelected.emit(parseInt(key));
  }

  onCalculateNonEditAmount() {
    if (this.paymentDetails.items.length > 0) {
      this.paymentDetails.items.forEach(paymentDetail => {
        let item = this.paymentMethods.find(x => x.key == paymentDetail.k.toString());
        if (item) {
          item.s_value = paymentDetail.v.toString();
        }
      });
    }
    switch (parseInt(this.selectedPaymentMode)) {
      case PaymentType.ShowQrCode: {
        this.toBePaid = this.billAmount;
      } break;
      case PaymentType.MultiPayment: {
        this.toBePaid = 0;
        this.paymentMethods.forEach(paymentMethod => {
          if (![PaymentType.MultiPayment, PaymentType.ShowQrCode].includes(parseInt(paymentMethod.key))) {
            if (paymentMethod.s_value) {
              this.toBePaid += parseFloat(paymentMethod.s_value);
            }
          } else {
            paymentMethod.s_value = '';
          }
        });
      } break;
      default: {
        if (!this.toBePaid) {
          if (this.paymentDetails.items.length > 0) {
            this.toBePaid = this.paymentDetails.items[0].v;
          } else {
            this.toBePaid = this.billAmount;
          }
        }
      } break;
    }
  }
}
